var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LoggingLevel } from '@augloop/interfaces';
var US_PER_MS = 1e3;
var TelemetryLogger = /** @class */ (function () {
    function TelemetryLogger(hostCallbacks) {
        this.level = LoggingLevel.info;
        this.hostCallbacks = hostCallbacks;
    }
    /* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
    TelemetryLogger.prototype.log = function (obj) {
        var _this = this;
        if (this.hostCallbacks == null || this.hostCallbacks.sendTelemetryEvent == null) {
            return;
        }
        var logToHost = function (op, opName, dataFields, ariaTenant, ariaNamespace) {
            var operationName = opName.charAt(0).toUpperCase() + opName.slice(1);
            var fieldsToLog = {
                ResourceId: op.resourceId,
                ResultDescription: op.resultDescription,
                ResultSignature: op.resultSignature,
                Dimension0: op.dimension0,
                Dimension1: op.dimension1,
                Dimension2: op.dimension2,
                Dimension3: op.dimension3
            };
            if (dataFields) {
                fieldsToLog = __assign(__assign({}, fieldsToLog), JSON.parse(dataFields));
            }
            _this.hostCallbacks.sendTelemetryEvent(ariaTenant ? ariaTenant : TelemetryLogger.augLoopAriaTenantToken, "".concat(ariaNamespace ? ariaNamespace : TelemetryLogger.augLoopAriaNamespace, "_").concat(operationName), fieldsToLog, 'Office.System.Activity', {
                CV: op.cv,
                Duration: (op.durationMs || 0) * US_PER_MS,
                Count: op.count,
                AggMode: 2 /*OnSuccess*/,
                Success: op.success
            }, false /*critical*/, 
            /* All AugLoop events currently log as Usage/Performance RSD */
            2 /* ProductServiceUsage */ | 4 /* ProductServicePerformance */, 110 /* RequiredServiceDataEvent */);
        };
        if (obj.eventName === 'Operation') {
            var op = obj;
            logToHost(op, op.operationName, op.dataFields);
        }
        else if (obj.eventName === 'SessionHealth') {
            var she = obj;
            logToHost(she, she.sessionHealthEventName);
        }
        else if (obj.eventName === 'WorkflowOperation') {
            var wfOp = obj;
            logToHost(wfOp, wfOp.operationName, wfOp.dataFields, wfOp.ariaTenant, wfOp.ariaNamespace);
        }
    };
    TelemetryLogger.augLoopAriaTenantToken = '3de4087d4de34817b1c376e3d1e6e293-983c4292-5ba9-485a-ab10-9797863c788b-6770';
    TelemetryLogger.augLoopAriaNamespace = 'Office_AugLoop_Client';
    return TelemetryLogger;
}());
export { TelemetryLogger };
//# sourceMappingURL=telemetry-logger.js.map